// src/plugins/axios.js
import Vue from "vue";
import axios from "axios";
import store from "../store/store";

// Carrega globals de forma síncrona (CommonJS) e com fallback seguro
let globals = {};
try {
  // webpack resolve require() em build e em dev
  // seu globals.js exporta via module.exports (CJS)
  // eslint-disable-next-line global-require
  globals = require("@/globals");
  // se por algum motivo vier embrulhado
  if (globals && typeof globals === "object" && "default" in globals) {
    globals = globals.default || globals;
  }
} catch (e) {
  globals = {};
}

// Resolve base da API com prioridade:
// 1) window.__ENV.API_BASE (env.js em produção via Nginx)
// 2) globals.BaseApiUrl (fallback do projeto)
// 3) "/api"
const runtimeEnv = (typeof window !== "undefined" && window.__ENV) || {};
const baseApiRaw = runtimeEnv.API_BASE || globals.BaseApiUrl || "/api";
// Normaliza para começar com "/"
const baseApi = String(baseApiRaw).startsWith("/")
  ? String(baseApiRaw)
  : `/${String(baseApiRaw).replace(/^\/+/, "")}`;

axios.defaults.baseURL = baseApi;

// Token do usuário (se existir)
try {
  const usuario = store.getters["usuario/getUsuario"];
  if (usuario && usuario.token) {
    axios.defaults.headers.common["Authorization"] = usuario.token;
  }
} catch (e) {
  // sem drama se a store ainda não estiver pronta
}

Vue.use({
  install(VueInstance) {
    VueInstance.prototype.$axios = axios;
  },
});

export default axios;
